import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { IWasteReceiptRow } from "../models/wasteTracking/IWasteReceiptRow";
import apiConfig from "../utils/apiConfig";
import { WASTE_TRACKING_TABLE_URL } from "./useWasteTracking";

// Waste movements a haulier account delivered - the Waste Movements tab on the account page.
export default function useAccountWasteReceipts(accountId?: string, componentName = "useAccountWasteReceipts") {
  const { get } = useApiHelper(apiConfig(componentName));

  const accountWasteReceipts = useQuery({
    queryKey: ["accounts", accountId, "waste-receipts"],
    queryFn: () => get<DefaultResponseWithData<IWasteReceiptRow[]>>(`${WASTE_TRACKING_TABLE_URL}/account/${accountId}`),
    enabled: !!accountId,
  });

  return {
    accountWasteReceipts,
  };
}
